export default __webpack_public_path__ + "static/media/bookingSquare.5dd6086f.svg";